var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "a-row",
                {
                  staticStyle: { "margin-bottom": "16px" },
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 8, sm: 24 } },
                    [
                      _c("a-statistic", {
                        attrs: { title: "训练状态", value: _vm.stateText },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 8, sm: 24 } },
                    [
                      _c("a-statistic", {
                        attrs: {
                          title: "进度",
                          value: _vm.statusInfo.progress || 0,
                          suffix: "%",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { md: 8, sm: 24 },
                    },
                    [
                      _vm.btnEnableList.indexOf(1) > -1 &&
                      _vm.statusInfo.state !== "running"
                        ? _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "play-circle",
                                loading: _vm.actionLoading,
                              },
                              on: { click: _vm.handleStart },
                            },
                            [_vm._v("启动训练")]
                          )
                        : _vm._e(),
                      _vm.btnEnableList.indexOf(1) > -1 &&
                      _vm.statusInfo.state === "running"
                        ? _c(
                            "a-button",
                            {
                              attrs: {
                                type: "danger",
                                icon: "pause-circle",
                                loading: _vm.actionLoading,
                              },
                              on: { click: _vm.handleStop },
                            },
                            [_vm._v("停止训练")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.statusInfo.state === "running"
                ? _c("a-progress", {
                    staticStyle: { "margin-bottom": "16px" },
                    attrs: { percent: _vm.statusInfo.progress || 0 },
                  })
                : _vm._e(),
              _c("a-divider"),
              _c(
                "a-form",
                { attrs: { labelCol: { span: 4 }, wrapperCol: { span: 19 } } },
                [
                  _c("a-form-item", { attrs: { label: "最近日志" } }, [
                    _c("pre", { staticClass: "train-log" }, [
                      _vm._v(_vm._s(_vm.statusInfo.log || "暂无日志")),
                    ]),
                  ]),
                  _c("a-form-item", { attrs: { label: "数据集目录" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "monospace" } },
                      [
                        _vm._v(
                          "service/dataset/images（原图） + service/dataset/labels（同名.json：4角点坐标）"
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "a-form-item",
                    { attrs: { label: "数据集状态" } },
                    [
                      _c(
                        "a-tag",
                        {
                          attrs: {
                            color: _vm.statusInfo.datasetReady
                              ? "green"
                              : "orange",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.statusInfo.datasetReady
                                  ? "已就绪"
                                  : "未就绪"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("a-alert", {
                staticStyle: { "margin-top": "8px" },
                attrs: {
                  type: "info",
                  showIcon: "",
                  message: "训练说明",
                  description:
                    "训练进程与推理进程相互隔离，训练期间对外角点检测接口继续使用旧模型不受影响。训练完成后需确认替换，新模型写入 service/models/ 生效，旧模型自动备份为 *.bak 支持一键回滚。数据集无需区分证件类型，所有证件混合训练。",
                },
              }),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-top": "16px" },
                  attrs: { icon: "reload" },
                  on: { click: _vm.loadStatus },
                },
                [_vm._v("刷新状态")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }